export default __webpack_public_path__ + "static/media/Phisical Inventory_Dark2.f9f1c2c4.svg";